import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
      <Card className="quote-card-view">
        <Card.Body>
          <blockquote className="blockquote mb-0">
            <p style={{ textAlign: "justify" }}>
              Hi everyone! I’m <b className="purple">Yicheng Zou</b>.
              <br />
              <br />

              I’m currently pursuing a{" "}
              <b className="purple">Master’s degree in Computer Science</b> at{" "}
              <b className="purple">Boston University</b>, with an academic
              background in <b className="purple">Economics</b> from{" "}
              <b className="purple">Simon Fraser University</b>.
              <br />
              <br />

              My experience spans{" "}
              <b className="purple">software engineering</b>,{" "}
              <b className="purple">full-stack development</b>, and{" "}
              <b className="purple">AI-powered applications</b>. I’ve worked on
              projects involving React, Spring Boot, AWS, PostgreSQL, Redis, RAG,
              and AI agents, with a focus on building practical and scalable
              products.
              <br />
              <br />

              I enjoy turning ideas into real applications and solving problems
              across both frontend and backend systems.
            </p>

            <ul>
              <li className="about-activity">
                <ImPointRight /> Software Engineering
              </li>

              <li className="about-activity">
                <ImPointRight /> Full-Stack Development
              </li>

              <li className="about-activity">
                <ImPointRight /> AI & Cloud Applications
              </li>
            </ul>

            <p style={{ color: "rgb(155 126 172)" }}>
              "Building practical software that turns ideas into real products."
            </p>

            <footer className="blockquote-footer">Yicheng Zou</footer>
          </blockquote>
        </Card.Body>
      </Card>
  );
}

export default AboutCard;